// extracted by mini-css-extract-plugin
module.exports = {"message-card":"messageCard_message-card__2Cprw","message-text":"messageCard_message-text__2W91r","shop-now-btn":"messageCard_shop-now-btn__2LKwX"};